import React, { useState } from 'react';
import { NavLink as Link } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { get } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as HokChevronUpIcon } from '../../img/icons/hok-chevron-up.svg';
import { ReactComponent as HokChevronDownIcon } from '../../img/icons/hok-chevron-down.svg';
import { USER_ACCOUNT_BUSINESS } from '../../constants/userDefs';
import { AdminEditRouting } from './AdminEditRouting';
import { ArrowLinkButton } from '../../containers';

export const AdminEditContainer = ({ user, userId, baseRoute, backRoute, isEmployee = false }) => {
  const getNavItems = user => {
    const navItems = [
      {
        name: 'accountData',
        route: `${baseRoute}/${userId}`,
      },
      {
        name: 'profileData',
        route: `${baseRoute}/${userId}/profile`,
      },
    ];

    if (get(user, 'verified', false)) {
      navItems.push(
        ...[
          {
            name: 'policiesData',
            route: `${baseRoute}/${userId}/policies`,
          },
          {
            name: 'invoicesData',
            route: `${baseRoute}/${userId}/invoices`,
          },
          {
            name: 'damagesData',
            route: `${baseRoute}/${userId}/damage-claims`,
          },
        ]
      );
    }

    navItems.push({ name: 'logsData', route: `${baseRoute}/${userId}/logs` });
    return navItems;
  };

  const [isDropdownOpen, toggleDropdown] = useState(false);

  const toggle = () => {
    toggleDropdown(!isDropdownOpen);
  };

  const renderTabsNavigation = () => (
    <Nav tabs className="hok-user-profile-tabs d-none d-lg-flex">
      {getNavItems(user).map(tab => (
        <NavItem key={tab.name}>
          <NavLink exact tag={Link} to={tab.route}>
            <FormattedMessage id={`adminEditUserPage.tabsNav.${tab.name}`} />
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );

  const renderSmallScreenTabsNav = () => (
    <Nav tabs className="hok-user-profile-tabs d-flex d-lg-none">
      <Dropdown nav isOpen={isDropdownOpen} toggle={toggle} className="hok-dropdown-tab-full">
        <DropdownToggle nav className="d-flex align-items-center justify-content-between">
          <FormattedMessage id={`adminEditUserPage.tabsNav.dropdownMenu`} />
          <div>
            <div>{isDropdownOpen ? <HokChevronUpIcon /> : <HokChevronDownIcon />}</div>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          {getNavItems(user).map(tab => (
            <DropdownItem exact key={tab.name} tag={Link} to={tab.route}>
              <FormattedMessage id={`adminEditUserPage.tabsNav.${tab.name}`} />
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </Nav>
  );

  const firstName = get(user, 'firstName', '');
  const lastName = get(user, 'lastName', '');
  const fullName = `${firstName ? firstName : ''} ${lastName ? lastName : ''}`;
  const businessName = get(user, 'businessName', '');

  return (
    <Container fluid className="mt-4">
      <ArrowLinkButton xlColSize="10" linkTo={null} />
      <Row className="my-4">
        <Col xs="12" xl={{ size: 10, offset: 1 }}>
          <h3 className="d-inline-block">
            <FormattedMessage id={`adminEditUserPage.${isEmployee ? 'displayedEmployee' : 'displayedUser'}`} />:
          </h3>
          <span className="hok-edit-user-name ml-0 ml-sm-2 d-block d-sm-inline">
            {get(user, 'sector', null) === USER_ACCOUNT_BUSINESS ? (
              businessName
            ) : fullName.trim() ? (
              fullName.trim()
            ) : (
              <FormattedMessage id={`adminEditUserPage.${isEmployee ? 'employee' : 'user'}`} />
            )}
          </span>
        </Col>
      </Row>
      <Row className="no-gutters">
        <Col xs="12" xl={{ size: 10, offset: 1 }}>
          {renderTabsNavigation()}
          {renderSmallScreenTabsNav()}
          <AdminEditRouting user={user} baseRoute={baseRoute} isEmployee={isEmployee} />
        </Col>
      </Row>
    </Container>
  );
};
